const BASE_URL = require('../config');
import React, { useState, useEffect } from 'react';

const API_URL = BASE_URL + '/api/expenses';
const PAYERS_API_URL = BASE_URL + '/api/expense_payers';

const PALETTE = [
  'bg-slate-200 text-slate-900', 'bg-red-200 text-red-900', 'bg-orange-200 text-orange-900',
  'bg-amber-200 text-amber-900', 'bg-emerald-200 text-emerald-900', 'bg-teal-200 text-teal-900',
  'bg-cyan-200 text-cyan-900', 'bg-blue-200 text-blue-900', 'bg-indigo-200 text-indigo-900', 'bg-purple-200 text-purple-900'
];

const toLocalIso = (d) => {
  const y = d.getFullYear(); const m = String(d.getMonth() + 1).padStart(2, '0'); const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

function SingleCalendar({ selected, onSelect, onClose }) {
  const [view, setView] = useState(selected ? new Date(selected) : new Date());
  const nextM = () => setView(new Date(view.getFullYear(), view.getMonth() + 1, 1));
  const prevM = () => setView(new Date(view.getFullYear(), view.getMonth() - 1, 1));
  const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
  const firstDay = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
  const offset = (firstDay + 6) % 7;
  const days = [];
  for(let i=0; i<offset; i++) days.push(null);
  for(let i=1; i<=daysInMonth; i++) days.push(new Date(view.getFullYear(), view.getMonth(), i));

  const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

  return (
    <div className="absolute top-full left-0 mt-2 bg-white border border-slate-200 shadow-2xl rounded-2xl p-5 w-[320px] z-50 cursor-default" onClick={e => e.stopPropagation()}>
       <div className="flex justify-between items-center mb-4"><button type="button" onClick={prevM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500 transition-colors">&lt;</button><span className="font-bold text-slate-800 text-sm uppercase tracking-wider">{monthNames[view.getMonth()]} {view.getFullYear()}</span><button type="button" onClick={nextM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500 transition-colors">&gt;</button></div>
       <div className="grid grid-cols-7 gap-1 text-center mb-2">{['Пн','Вт','Ср','Чт','Пт','Сб','Вс'].map(w => <div key={w} className="text-[10px] font-bold text-slate-400">{w}</div>)}</div>
       <div className="grid grid-cols-7 gap-1 text-center">
         {days.map((d, i) => {
            if(!d) return <div key={i} className="w-9 h-9" />;
            const isSel = selected === toLocalIso(d);
            return (<div key={i} onClick={() => { onSelect(toLocalIso(d)); onClose(); }} className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm cursor-pointer transition-all ${isSel ? 'bg-red-500 text-white font-bold shadow-md scale-105' : 'text-slate-700 hover:bg-slate-100'}`}>{d.getDate()}</div>)
         })}
       </div>
    </div>
  );
}


function RangeCalendar({ start, end, onSelect, onClose }) {
  const [view, setView] = useState(start ? new Date(start) : new Date());
  const nextM = () => setView(new Date(view.getFullYear(), view.getMonth() + 1, 1));
  const prevM = () => setView(new Date(view.getFullYear(), view.getMonth() - 1, 1));
  const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
  const firstDay = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
  const offset = (firstDay + 6) % 7;
  const days = [];
  for(let i=0; i<offset; i++) days.push(null);
  for(let i=1; i<=daysInMonth; i++) days.push(new Date(view.getFullYear(), view.getMonth(), i));

  const handleDay = (d) => {
    if(!d) return;
    const dStr = toLocalIso(d);
    if (!start || (start && end)) { onSelect(dStr, ''); }
    else {
      const sTime = new Date(start).getTime();
      if (d.getTime() < sTime) { onSelect(dStr, start); onClose(); }
      else { onSelect(start, dStr); onClose(); }
    }
  };

  const isSelected = (d) => { if(!d) return false; const dt = toLocalIso(d); return dt === start || dt === end; };
  const isInRange = (d) => { if(!d || !start || !end) return false; const t = d.getTime(); return t > new Date(start).getTime() && t < new Date(end).getTime(); };
  const monthNames = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];

  return (
    <div className="absolute top-full left-0 mt-2 bg-white border border-slate-200 shadow-2xl rounded-2xl p-5 w-[320px] z-50 cursor-default" onClick={e => e.stopPropagation()}>
      <div className="flex justify-between items-center mb-4">
        <button type="button" onClick={prevM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500">&lt;</button>
        <span className="font-bold text-slate-800 text-sm uppercase tracking-wider">{monthNames[view.getMonth()]} {view.getFullYear()}</span>
        <button type="button" onClick={nextM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500">&gt;</button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center mb-2">{['Пн','Вт','Ср','Чт','Пт','Сб','Вс'].map(w => <div key={w} className="text-[10px] font-bold text-slate-400">{w}</div>)}</div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {days.map((d, i) => {
          if(!d) return <div key={i} className="w-9 h-9" />;
          const sel = isSelected(d); const inR = isInRange(d);
          return (<div key={i} onClick={() => handleDay(d)} className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm cursor-pointer transition-all ${sel ? 'bg-red-500 text-white font-bold shadow-md scale-105' : (inR ? 'bg-red-100 text-red-800' : 'text-slate-700 hover:bg-slate-100')}`}>{d.getDate()}</div>)
        })}
      </div>
      <div className="mt-4 border-t border-slate-100 pt-3 flex justify-between items-center">
        <button type="button" onClick={() => onSelect('','')} className="text-xs text-slate-400 hover:text-red-500 font-bold">Сбросить</button>
        <button type="button" onClick={onClose} className="text-xs bg-slate-800 text-white px-3 py-1.5 rounded font-bold">Готово</button>
      </div>
    </div>
  );
}
function SearchableSelect({ options, value, onChange, placeholder }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [debounced, setDebounced] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebounced(search), 250);
    return () => clearTimeout(t);
  }, [search]);
  const filtered = options.filter(c => c.name.toLowerCase().includes(debounced.toLowerCase()));
  return (
    <div className="relative w-full min-w-[120px]">
      <div onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }} className="border border-red-400 p-1.5 rounded bg-white cursor-pointer flex justify-between items-center shadow-inner">
        <span className={value ? "text-slate-800 truncate text-xs text-left" : "text-slate-400 truncate text-xs text-left"}>{value || placeholder}</span><span className="text-slate-400 text-[10px] ml-1">▼</span>
      </div>
      {isOpen && (
        <div className="absolute z-50 min-w-[200px] w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-xl max-h-60 overflow-y-auto left-0" onClick={e => e.stopPropagation()}>
          <div className="p-1.5 sticky top-0 bg-white border-b border-slate-100"><input type="text" placeholder="Поиск..." value={search} onChange={e => setSearch(e.target.value)} autoFocus className="w-full border border-slate-200 p-1.5 rounded focus:outline-none focus:ring-1 focus:ring-red-500 text-xs text-left" /></div>
          {filtered.map(c => {
             const bgClass = c.color ? c.color.split(' ')[0] : null;
             return (<div key={c.id} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange(c.name); setIsOpen(false); setSearch(''); }} className="p-2 hover:bg-red-50 cursor-pointer text-slate-700 border-b border-slate-50 last:border-0 flex items-center text-xs text-left">{bgClass && <div className={`w-2.5 h-2.5 rounded-full mr-1.5 shrink-0 ${bgClass}`}></div>}{c.name}</div>)
          })}
        </div>
      )}
    </div>
  );
}

function DictionaryModal({ title, isOpen, onClose, items, onAdd, onUpdate, onDelete }) {
  const [newName, setNewName] = useState(''); const [newColor, setNewColor] = useState(PALETTE[0]); const [editingId, setEditingId] = useState(null); const [editName, setEditName] = useState(''); const [editColor, setEditColor] = useState('');
  useEffect(() => { if (isOpen) { setNewColor(PALETTE[0]); setNewName(''); setEditingId(null); } }, [isOpen]);
  if (!isOpen) return null;
  const handleAdd = () => { if (newName.trim()) { onAdd(newName, newColor); setNewName(''); setNewColor(PALETTE[0]); } };
  const handleUpdate = (id) => { if (editName.trim()) { onUpdate(id, editName, editColor); setEditingId(null); setEditName(''); } };

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-[100] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl w-full max-w-lg shadow-2xl overflow-hidden flex flex-col max-h-[80vh]">
        <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50"><h2 className="text-lg font-bold text-slate-800 text-left">{title}</h2><button onClick={onClose} className="text-slate-400 hover:text-red-500 font-bold text-lg px-2">✕</button></div>
        <div className="p-4 overflow-y-auto flex-1">
          <div className="mb-4 p-3 bg-slate-50 border border-slate-100 rounded-lg">
            <div className="flex space-x-2"><input type="text" placeholder="Новое значение..." value={newName} onChange={(e) => setNewName(e.target.value)} className="flex-1 border border-slate-300 p-2 rounded focus:ring-1 focus:ring-red-500 outline-none text-sm text-left" /><button onClick={handleAdd} className="bg-red-500 hover:bg-red-600 text-white px-4 rounded font-semibold shadow-sm transition-colors text-sm">Добавить</button></div>
            <div className="flex items-center mt-3"><span className="text-xs text-slate-500 uppercase font-bold mr-2 w-10 text-left">Цвет:</span><div className="flex flex-wrap gap-1.5">{PALETTE.map(c => { const isSelected = newColor === c; return (<div key={c} onClick={() => setNewColor(c)} className={`w-6 h-6 rounded-full cursor-pointer flex items-center justify-center transition-all ${c.split(' ')[0]} ${isSelected ? 'ring-2 ring-offset-1 ring-slate-400 scale-110' : 'opacity-70 hover:opacity-100'}`}>{isSelected && <span className={`font-bold text-[10px] ${c.split(' ')[1]}`}>✓</span>}</div>); })}</div></div>
          </div>
          <div className="space-y-2">
            {items.map(item => (
              <div key={item.id} className="p-3 bg-white border border-slate-200 rounded-lg hover:shadow-sm transition-shadow">
                {editingId === item.id ? (
                  <div className="flex flex-col space-y-3">
                    <div className="flex space-x-2"><input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus className="flex-1 border border-red-300 p-1.5 rounded outline-none focus:ring-1 focus:ring-red-500 text-sm text-left" /><button onClick={() => handleUpdate(item.id)} className="bg-emerald-500 hover:bg-emerald-600 text-white px-3 py-1.5 rounded text-xs font-bold">✓</button><button onClick={() => setEditingId(null)} className="bg-slate-200 hover:bg-slate-300 text-slate-700 px-3 py-1.5 rounded text-xs font-bold">✕</button></div>
                    <div className="flex items-center mt-3 pt-2 border-t border-slate-100"><span className="text-xs text-slate-500 uppercase font-bold mr-2 w-10 text-left">Цвет:</span><div className="flex flex-wrap gap-1.5">{PALETTE.map(c => { const isSelected = editColor === c; return (<div key={c} onClick={() => setEditColor(c)} className={`w-6 h-6 rounded-full cursor-pointer flex items-center justify-center transition-all ${c.split(' ')[0]} ${isSelected ? 'ring-2 ring-offset-1 ring-slate-400 scale-110' : 'opacity-70 hover:opacity-100'}`}>{isSelected && <span className={`font-bold text-[10px] ${c.split(' ')[1]}`}>✓</span>}</div>); })}</div></div>
                  </div>
                ) : (
                  <div className="flex justify-between items-center">
                    <div className="flex items-center"><div className={`w-3 h-3 rounded-full mr-2 ${(item.color || PALETTE[0]).split(' ')[0]}`}></div><span className="font-semibold text-slate-700 text-sm flex-1 text-left">{item.name}</span></div>
                    <div className="flex space-x-2"><button onClick={() => { setEditingId(item.id); setEditName(item.name); setEditColor(item.color || PALETTE[0]); }} className="text-red-500 hover:text-red-700 font-medium text-xs px-2">Изменить</button><button onClick={() => { if(window.confirm('Точно удалить?')) onDelete(item.id); }} className="text-red-400 hover:text-red-600 font-medium text-xs px-2">Удалить</button></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const InlineActions = ({ onSave, onCancel }) => (
  <div className="flex space-x-1 ml-2">
    <button onClick={onSave} className="bg-emerald-500 text-white rounded hover:bg-emerald-600 flex items-center justify-center w-6 h-6 shadow-sm transition-transform hover:scale-105 shrink-0">✓</button>
    <button onClick={onCancel} className="bg-red-400 text-white rounded hover:bg-red-500 flex items-center justify-center w-6 h-6 shadow-sm transition-transform hover:scale-105 shrink-0">✕</button>
  </div>
);

export default function ExpensesPage() {
  const [expenses, setExpenses] = useState([]);
  const [payers, setPayers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  
  const [amount, setAmount] = useState('');
  const [payer, setPayer] = useState('');
  const [comment, setComment] = useState('');
  
  const [formDate, setFormDate] = useState(toLocalIso(new Date()));
  const [formDateEnd, setFormDateEnd] = useState('');
  const [isPeriod, setIsPeriod] = useState(false);
  const [showFormCal, setShowFormCal] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [editingCell, setEditingCell] = useState(null); 
  const [cellEditValue, setCellEditValue] = useState('');
  const [showCellCal, setShowCellCal] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (editingCell) { setEditingCell(null); setCellEditValue(''); setShowCellCal(false); }
        if (showForm) { setShowForm(false); setAmount(''); setPayer(''); setComment(''); setFormDate(toLocalIso(new Date())); setFormDateEnd(''); setIsPeriod(false); }
        if (showFormCal) { setShowFormCal(false); }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [editingCell, showForm, showFormCal]);

  const fetchData = async () => {
    try {
      const [expRes, payRes] = await Promise.all([ fetch(API_URL, { headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }), fetch(PAYERS_API_URL, { headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }) ]);
      if (expRes.ok) setExpenses(await expRes.json());
      if (payRes.ok) setPayers(await payRes.json());
    } catch (error) { console.error('Ошибка:', error); }
  };
  useEffect(() => { fetchData(); }, []);

  const addDictItem = async (url, name, color) => { await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name, color }) }); fetchData(); };
  const updateDictItem = async (url, id, name, color) => { await fetch(`${url}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name, color }) }); fetchData(); };
  const deleteDictItem = async (url, id) => { await fetch(`${url}/${id}`, { method: 'DELETE', headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }); fetchData(); };

  const handleAdd = async () => {
    if (!amount || !payer) return alert("Заполните 'Сумма' и 'Плательщик'");
    
    const dateValue = isPeriod && formDateEnd ? `${formDate} — ${formDateEnd}` : formDate;
    const payload = { amount: parseFloat(amount), date: dateValue, payer, comment };
    try { 
      const res = await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); 
      if (res.ok) { setAmount(''); setPayer(''); setComment(''); setFormDate(toLocalIso(new Date())); setFormDateEnd(''); setIsPeriod(false); setShowForm(false); fetchData(); } 
    } catch (error) { alert('Ошибка соединения'); }
  };

  const toggleSelect = (id) => { if (selectedIds.includes(id)) setSelectedIds(selectedIds.filter(i => i !== id)); else setSelectedIds([...selectedIds, id]); };
  const deleteSelected = async () => { if (!window.confirm(`Удалить ${selectedIds.length} записей?`)) return; try { await fetch(BASE_URL + '/api/expenses/batch', { method: 'DELETE', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ ids: selectedIds }) }); setSelectedIds([]); fetchData(); } catch (error) { alert('Ошибка при удалении'); } };

  const startCellEdit = (exp, field) => { 
    setEditingCell({ id: exp.id, field }); 
    setCellEditValue(exp[field] || ''); 
    if(field === 'date') setShowCellCal(true);
  };
  const cancelCellEdit = (e) => { if(e) e.stopPropagation(); setEditingCell(null); setCellEditValue(''); setShowCellCal(false); };

  const saveCellEdit = async (e) => {
    if(e) e.stopPropagation();
    if (!editingCell) return;
    const { id, field } = editingCell;
    const exp = expenses.find(p => p.id === id);
    if (!exp) return;

    const payload = { ...exp };
    if (field === 'amount') payload.amount = parseFloat(cellEditValue) || 0;
    else payload[field] = cellEditValue;

    try { await fetch(`${API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); setEditingCell(null); setShowCellCal(false); fetchData(); } catch (error) { alert('Ошибка сохранения'); }
  };

  const handleDirectSave = async (val, field) => {
    if (!editingCell) return;
    const { id } = editingCell;
    const exp = expenses.find(p => p.id === id);
    if (!exp) return;

    const payload = { ...exp };
    payload[field] = val;

    try { await fetch(`${API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); setEditingCell(null); fetchData(); } catch (error) { alert('Ошибка сохранения'); }
  };

  const renderCell = (colId, exp, isSelected) => {
    const isCellEditing = editingCell?.id === exp.id && editingCell?.field === colId;
    const cellClass = `px-4 py-3 cursor-pointer hover:bg-red-50/70 transition-colors border-r border-slate-200 last:border-r-0 text-left`;
    const handleClick = () => { if (!isCellEditing && colId !== 'checkbox' && colId !== 'id') startCellEdit(exp, colId); };
    const payColorClass = payers.find(s => s.name === exp.payer)?.color || PALETTE[0];

    if (isCellEditing) {
      let inputElement;
      const isDropdown = colId === 'payer';
      
      if (colId === 'payer') inputElement = <SearchableSelect options={payers} value={cellEditValue} onChange={(v) => { setCellEditValue(v); handleDirectSave(v, colId); }} placeholder="Выбрать..." />;
      else if (colId === 'date') inputElement = (
        <div className="relative w-full">
          <input type="text" readOnly value={cellEditValue} onClick={(e) => { e.stopPropagation(); setShowCellCal(!showCellCal); }} className="w-full border border-red-400 p-1.5 rounded text-xs outline-none cursor-pointer bg-white" placeholder="Выберите дату..." />
          {showCellCal && <SingleCalendar selected={cellEditValue} onSelect={(d) => setCellEditValue(d)} onClose={() => setShowCellCal(false)} />}
        </div>
      );
      else if (colId === 'amount') inputElement = <input type="number" value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} autoFocus className="w-full border border-red-400 p-1.5 rounded text-xs outline-none shadow-inner text-left" />;
      else inputElement = <input type="text" value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} autoFocus className="w-full border border-red-400 p-1.5 rounded text-xs outline-none shadow-inner text-left" />;

      return (
        <td key={colId} className="px-4 py-3 bg-red-50 border-r border-slate-200 last:border-r-0 overflow-visible">
          <div className="flex items-center w-full min-w-[150px]">
            {inputElement}
            {!isDropdown && <InlineActions onSave={saveCellEdit} onCancel={cancelCellEdit} />}
          </div>
        </td>
      );
    }

    switch(colId) {
      case 'checkbox': return <td key={colId} className="px-4 py-3 border-r border-slate-200 text-left"><input type="checkbox" checked={isSelected} onChange={() => toggleSelect(exp.id)} className="w-4 h-4 text-red-500 rounded cursor-pointer" /></td>;
      case 'id': return <td key={colId} className={`px-4 py-3 border-r border-slate-200 text-slate-400 font-mono text-left`}>#{exp.id}</td>;
      case 'amount': return <td key={colId} onClick={handleClick} className={`${cellClass} font-black text-red-500 whitespace-nowrap text-base`} title="Нажмите для редактирования">- {exp.amount} ₽</td>;
      case 'date': return <td key={colId} onClick={handleClick} className={`${cellClass} text-slate-600 font-bold whitespace-nowrap`} title="Нажмите для редактирования">📅 {exp.date ? exp.date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$3.$2.$1').replace(' — ', ' — ') : '-'}</td>;
      case 'payer': return <td key={colId} onClick={handleClick} className={cellClass} title="Нажмите для редактирования"><span className={`px-2 py-0.5 rounded text-xs font-bold shadow-sm ${payColorClass}`}>{exp.payer || '-'}</span></td>;
      case 'comment': return <td key={colId} onClick={handleClick} className={`${cellClass} text-slate-500 min-w-[200px] max-w-[400px] whitespace-normal break-words`} title="Нажмите для редактирования">{exp.comment || '-'}</td>;
      default: return null;
    }
  };

  const cols = ['checkbox', 'id', 'amount', 'date', 'payer', 'comment'];
  const totalExpenses = expenses.reduce((sum, e) => sum + (e.amount || 0), 0);

  return (
    <div className="max-w-[1500px] mx-auto pb-48 relative mt-0 px-2 mt-0 mt-0">
      <div className="flex justify-between items-center mb-1 h-[32px]">
        <h1 className="text-[11px] font-bold text-slate-700">Учёт трат</h1>
        <div className="flex space-x-3 items-center">
          <div className="text-sm font-bold text-slate-500 bg-white border border-slate-200 px-4 py-2 rounded-lg shadow-sm">
            Итого расходов: <span className="text-red-500 ml-1 text-lg">- {new Intl.NumberFormat('ru-RU').format(totalExpenses)} ₽</span>
          </div>
          {selectedIds.length > 0 && <button onClick={deleteSelected} className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded font-semibold shadow-sm transition-colors text-sm">Удалить ({selectedIds.length})</button>}
          <button onClick={() => setShowForm(!showForm)} className="bg-red-500 hover:bg-red-600 text-white px-2 py-0.5 rounded font-semibold transition-colors text-[11px]">{showForm ? 'Скрыть' : '+ Трату'}</button>
        </div>
      </div>

      {showForm && (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-red-200 mb-6 bg-red-50/30">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
            <div className="col-span-1">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Сумма (₽) *</label>
              <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="w-full border border-slate-300 p-2 rounded text-sm focus:ring-1 focus:ring-red-500 font-bold text-red-500" placeholder="0" />
            </div>
            <div className="col-span-1 relative">
              <div className="flex items-center justify-between mb-1">
                <label className="text-[10px] text-slate-500 font-bold uppercase">Дата</label>
                <label className="flex items-center space-x-1 cursor-pointer">
                  <input type="checkbox" checked={isPeriod} onChange={e => { setIsPeriod(e.target.checked); setFormDateEnd(''); if(e.target.checked) setFormDate(''); else setFormDate(toLocalIso(new Date())); }} className="w-3 h-3 accent-red-500" />
                  <span className="text-[10px] text-slate-500 font-bold uppercase">Период</span>
                </label>
              </div>
              {!isPeriod ? (
                <div className="relative">
                  <input type="text" readOnly value={formDate ? formDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1') : ''} onClick={() => setShowFormCal(!showFormCal)} className="w-full border border-slate-300 p-2 rounded text-sm outline-none cursor-pointer" />
                  {showFormCal && <SingleCalendar selected={formDate} onSelect={(d) => setFormDate(d)} onClose={() => setShowFormCal(false)} />}
                </div>
              ) : (
                <div className="relative">
                  <input type="text" readOnly value={(() => {
                    const fmt = d => d ? d.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1') : '';
                    if (formDate && formDateEnd) return `${fmt(formDate)} — ${fmt(formDateEnd)}`;
                    if (formDate) return `${fmt(formDate)} — ...`;
                    return 'Выберите период...';
                  })()} onClick={() => setShowFormCal(!showFormCal)} className="w-full border border-slate-300 p-2 rounded text-sm outline-none cursor-pointer text-slate-700" />
                  {showFormCal && <RangeCalendar start={formDate} end={formDateEnd} onSelect={(s, e) => { setFormDate(s); setFormDateEnd(e); }} onClose={() => setShowFormCal(false)} />}
                </div>
              )}
            </div>
            <div className="col-span-1">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Плательщик *</label>
              <SearchableSelect options={payers} value={payer} onChange={setPayer} placeholder="Выбрать..." />
            </div>
            <div className="col-span-1 md:col-span-1">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Комментарий</label>
              <input type="text" value={comment} onChange={(e) => setComment(e.target.value)} className="w-full border border-slate-300 p-2 rounded text-sm focus:ring-1 focus:ring-red-500" placeholder="На что ушли деньги?" />
            </div>
            <div className="col-span-1">
              <button onClick={handleAdd} className="w-full bg-red-500 hover:bg-red-600 text-white p-2 rounded font-bold shadow-sm text-sm">Записать</button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
        <table className="min-w-full text-left whitespace-nowrap text-xs">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3 w-10 border-r border-slate-200"></th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">ID</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Сумма</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Дата</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">
                <div className="flex items-center justify-between group">
                  <span>Плательщик</span>
                  <span onClick={() => setModalType('payer')} title="Настроить плательщиков" className="text-[12px] opacity-30 cursor-pointer hover:opacity-100 hover:scale-125 transition-all px-1 hidden group-hover:block">⚙️</span>
                </div>
              </th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Комментарий</th>
            </tr>
          </thead>
          <tbody>
            {expenses.length === 0 ? (
               <tr><td colSpan={6} className="px-6 py-12 text-center text-slate-500">Пока нет никаких трат.</td></tr>
            ) : expenses.map((exp) => (
              <tr key={exp.id} className={`border-b border-slate-200 hover:bg-slate-50 transition-colors ${selectedIds.includes(exp.id) ? 'bg-red-50/50' : ''}`}>
                {cols.map(colId => renderCell(colId, exp, selectedIds.includes(exp.id)))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <DictionaryModal title="Кто платит (Источники)" isOpen={modalType === 'payer'} onClose={() => setModalType(null)} items={payers} onAdd={(name, color) => addDictItem(PAYERS_API_URL, name, color)} onUpdate={(id, name, color) => updateDictItem(PAYERS_API_URL, id, name, color)} onDelete={(id) => deleteDictItem(PAYERS_API_URL, id)} />
    </div>
  );
}
